export const Footer = () => {
	const year = new Date().getFullYear();
	return (
		<footer className="border-t bg-navy/20 text-black py-12 w-full flex justify-center">
			<div className="container max-w-8xl mx-auto">
				<div className="grid md:grid-cols-4 gap-8 text-center md:text-left">
					<div>
						<img
							src="/gova_logo.png"
							alt="Gova Engineering Logo"
							className="h-24 mx-auto md:mx-0"
						/>
						<p className="pt-4 text-sm text-black">
							Central Texas engineering solutions with local expertise in
							Austin, Travis County, and surrounding areas.
						</p>
					</div>

					<div>
						<h4 className="mb-4">Services</h4>
						<div className="space-y-2 text-sm text-black">
							<div>Civil Engineering</div>
							<div>Water &amp; Wastewater Tap Plans</div>
							<div>Permitting &amp; Compliance</div>
							<div>Site Development</div>
							<div>Project Management</div>
						</div>
					</div>

					<div>
						<h4 className="mb-4">Service Areas</h4>
						<div className="space-y-2 text-sm text-black">
							<div>Austin &amp; Travis County</div>
							<div>Bastrop County</div>
							<div>Caldwell County</div>
							<div>Hays County</div>
							<div>Williamson County</div>
						</div>
					</div>

					<div>
						<h4 className="mb-4">Contact</h4>
						<div className="space-y-2 text-sm text-black">
							<div>miguel@govaengineering.com</div>
							<div>Austin, Texas</div>
						</div>
					</div>
				</div>

				<div className="border-t border-slate-600 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center text-center md:text-left">
					<div className="text-sm text-slate-400">
						© {year} Website by{" "}
						<a
							href="https://www.nichedoor.com"
							target="_blank"
							rel="noopener noreferrer"
							className="underline hover:text-blue"
						>
							Nichedoor - Local Web Design & SEO Experts
						</a>
						. All Rights Reserved.
					</div>
					<div className="flex flex-col md:flex-row items-center gap-4 text-sm text-black">
						<a
							href="mailto:miguel@govaengineering.com"
							className="hover:text-blue transition-colors"
						>
							miguel@govaengineering.com
						</a>
					</div>
				</div>
			</div>
		</footer>
	);
};
